<template>
  <div class="PaginationControls">
    <button v-show="currentPageNo > 0"
      class="button prevButton"
      @click="selectPage(currentPageNo - 1)"
    >
      <span class="arrow" v-html="arrowLeftSvg" />
      <span class="label">{{ localeStrings.previous }}</span>
    </button>
    <span v-for="pageNo, index in pageNosToShow" :key="index">
      <button v-if="pageNo !== null"
        class="button pageButton"
        :class="currentPageNo === pageNo && 'active'"
        @click="selectPage(pageNo)"
      >
        {{ pageNo + 1 }}
      </button>
      <span v-else class="ellipsis">...</span>
    </span>
    <button v-show="currentPageNo < totalPages - 1"
      class="button nextButton"
      @click="selectPage(currentPageNo + 1)"
    >
      <span class="label">{{ localeStrings.next }}</span>
      <span class="arrow" v-html="arrowRightSvg" />
    </button>
  </div>
</template>

<script>
import strings from '../strings.json'
import arrowLeftSvg from '~/assets/ui/arrow-left.svg?raw'
import arrowRightSvg from '~/assets/ui/arrow-right.svg?raw'

// E.g., integers(5) => [0, 1, 2, 3, 4]
function integers(length) {
  return Array.from(Array(length).keys())
}

export default {
  inject: ['locale'],
  props: {
    currentPageNo: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    selectPage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      arrowLeftSvg, arrowRightSvg
    }
  },
  computed: {
    // If we have too many pages, hide some of them (replace with '...')
    pageNosToShow() {
      const pageNos = integers(this.totalPages)
      const desiredElemCount = 7
      const numPagesToHide = this.totalPages - desiredElemCount + 1
      if (numPagesToHide > 0) {
        if (this.currentPageNo >= this.totalPages / 2) {
          pageNos.splice(1, numPagesToHide, null)
        }
        else {
          pageNos.splice(this.totalPages - numPagesToHide - 1, numPagesToHide, null)
        }
      }
      return pageNos
    },
    localeStrings() {
      return strings[this.locale]
    },
  },
}
</script>

<style scoped>

.PaginationControls {

  border-top: thin solid var(--hairline-color);
  padding-top: var(--spacing-3);
  position: relative;

  font-weight: 400;
  font-size: var(--font-size-1);
  line-height: 1.5em;
  color: var(--text-color-black);

  text-align: center;
}

.button {
  transition: color 0.15s;
}

.button:hover {
  color: var(--brand-color);
}

.button .arrow {
  display: inline-block;
  vertical-align: sub;
}

.button .label {
  display: none;
}

.prevButton {
  position: absolute;
  left: 0;
}

.prevButton .arrow {
  margin-right: 1em;
}

.nextButton {
  position: absolute;
  right: 0;
}

.nextButton .arrow {
  margin-left: 1em;
}

.pageButton, .ellipsis {
  margin: 0 0.5em;
  width: 1.5em;
  text-align: center;
}

.pageButton {
  border-bottom: 2px solid transparent;
}

.pageButton.active {
  font-weight: 500;
  border-color: currentColor;
}

@media (--screen-md) {
  .button .label {
    display: inline;
  }
}
</style>
